import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Plus, CheckCircle2 } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function AddToDashboardButton({ moduleId, label }) {
  const { token } = useAuth();
  const [added, setAdded] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAdd = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (added || loading) return;
    setLoading(true);
    try {
      await axios.post(`${API}/college/dashboard-add-module`, { module_id: moduleId }, { headers: { Authorization: `Bearer ${token}` } });
      setAdded(true);
    } catch {}
    setLoading(false);
  };

  return (
    <button onClick={handleAdd} disabled={added || loading}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-medium border transition-all ${
        added
          ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-300'
          : 'border-[#00e5ff30] bg-[#00e5ff08] text-[#00e5ff] hover:bg-[#00e5ff15] hover:border-[#00e5ff50]'
      }`}
      data-testid={`add-to-dash-${moduleId}`}>
      {added ? <><CheckCircle2 className="w-3 h-3" /> On Dashboard</> :
       loading ? 'Adding...' :
       <><Plus className="w-3 h-3" /> {label || 'Add to Dashboard'}</>}
    </button>
  );
}
